import { useEffect, useState } from "react";

/**
 * True on desktop-width viewports (≥1024px), matching Tailwind's `lg:` breakpoint.
 *
 * The app is mobile-first and renders inside a column that widens on large
 * screens, so a few rails need a JS breakpoint (not just CSS) to decide how
 * many items justify a "See all" affordance. Starts `false` (mobile-first)
 * and syncs on mount; no window access at module scope keeps SSR/test-safe.
 */
export default function useIsDesktop(query = "(min-width: 1024px)") {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const update = () => setIsDesktop(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, [query]);

  return isDesktop;
}
